import { ToastContainerProps } from 'react-toastify'

export const reactToastifyConfig: ToastContainerProps = {
  position: 'bottom-right',
  autoClose: 5000,
  pauseOnFocusLoss: false,
  closeOnClick: true
}
